import { HTMLAttributes } from 'react';
import classNames from 'classnames';
import 'app/agriculture/forms/components/InputLabel/InputLabel.scss';

interface InputLabelProps extends HTMLAttributes<HTMLLabelElement> {
    className?: string;
    id: string;
    children: string;
}

export function InputLabel({ className, id, children, ...labelProps }: InputLabelProps) {
    return (
        <label id={id} className={classNames(className, 'InputLabel')} {...labelProps}>
            {children}
        </label>
    );
}
